import React from 'react';
import { Link } from 'react-router-dom';

const SchoolSecurity = () => {
    return (
        <>
            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                <div className="breadcromb-top school-security-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-top-text">
                                    <h2 className="banner-heading">School Security</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><Link to="/">home</Link></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>School Security</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}

             <section class="bleezy-blog-page-area" style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                <div class="container">
                    <div class="mid-title  mb-5 "><h2 class="heading-with-border"><strong>School Security</strong></h2>
                        <h3 className="sub-heading-page sub-heading-m-t-15"><strong>Educational Institute Security in India</strong></h3>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                           Security of a School is a highly sensitive matter as it involves securing innocent school children who are vulnerable to crime and easy target of impostors. If proper attention is not paid to safety and security of school premises, it may cause serious harm to the students and image of the school. A serious crime against students within the school premises may permanently tarnish image of the school and eventually lead to criminal liability and closure of the school. Similarly, security of college and hostel requires special attention to debar entry of anti social elements inside the campus and safeguard students. Therefore, importance of educational institute security cannot be underplayed in today’s times and appointment of professional, alert, trained and experience security is of paramount importance.
                        </p>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                           A professional security not only safeguard students and the institute, but also helps the educational institute in building trust amongst parents and uplifting overall image of the institute. We provide best school security service in India.
                        </p>

                        <h3 className="sub-heading-page sub-heading-m-t-15 "><strong>Safety Measure for School designed by Octopuss Security</strong></h3>

                        <p className="octo-para" style={{ marginTop: '18px' }}>
                            Most important part of any School Security is access control. If unauthorised entry and exit is safeguarded, security of the school cannot be breached. Therefore, security must ensure that no unauthorised person enters the school premises. At the same time, school must ensure that no toddler is handed over to any person without proper ID authentication. Therefore, our security personnel execute 100% control on school gate with 0% tolerance. At the same time, our security is sensitise to handle students and visitors without causing them any hurdle. We create checkpoints and post inside the school premises, where our guards keep total vigilance during the working hours of the school. Security Supervisor conducts regular patrolling to check for any security breach or untoward incident. CCTV is continuously monitored by our dedicated security staff to check and report any untoward incident.
                        </p>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15 ">
                           As an additional safety measure, we provide fire fighting and first aid training to security and school staffs. We also help the school in implementing Fire Safety Policy for Schools as drafted by Maharashtra Fire Service. Fire training not only help schools to combat fire, but also train students about fire which may, in the long run, save their life in case of fire. We provide these additional services at no extra cost.
                        </p>

                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                          When your school is secured by Octopuss Security, 100% reliability is assured. Our innovative approach makes us the top school security agency in India.
                        </p>

                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15" style={{fontStyle:'italic'}}>
                           “A professional Security in the long run will prove to be a better investment than expenditure of any kind, on upkeep of school premises.”
                        </p>
                    </div>
                </div>
            </section>


        </>
    )
}

export default SchoolSecurity;
